import * as i0 from '@angular/core';
import { Injectable, EventEmitter, Component, Input, Output, NgModule } from '@angular/core';
import { Subject } from 'rxjs';
import * as i1 from '@ngrx/store';
import { select } from '@ngrx/store';
import { environment } from 'environment-configurations';
import { takeUntil } from 'rxjs/internal/operators/takeUntil';
import { Subject as Subject$1 } from 'rxjs/internal/Subject';
import { TaskStep, acceptedFileTypes } from 'app-models';
import { getStepDetails } from 'visa-store';
import * as i2 from 'ngx-toastr';
import * as i3 from 'base-generate-forms-library';
import { BaseGenerateFormsLibraryService } from 'base-generate-forms-library';
import * as i4 from 'step-status-update-payload-service';
import * as i5 from 'reference-library';
import * as i7 from '@angular/common';
import * as i8 from '@angular/material/icon';
import { PrimengLibraryModule } from 'primeng-library';

class OverideUploadFormsLibraryService {
    constructor() {
        this.fetchi140StepDetails = new Subject();
        this.receivei140StepDetails = new Subject();
    }
}
OverideUploadFormsLibraryService.ɵfac = function OverideUploadFormsLibraryService_Factory(t) { return new (t || OverideUploadFormsLibraryService)(); };
OverideUploadFormsLibraryService.ɵprov = i0.ɵɵdefineInjectable({ token: OverideUploadFormsLibraryService, factory: OverideUploadFormsLibraryService.ɵfac, providedIn: 'root' });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(OverideUploadFormsLibraryService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return []; }, null); })();

function OverideUploadFormsLibraryComponent_div_1_Template(rf, ctx) { if (rf & 1) {
    const _r4 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 2);
    i0.ɵɵelement(1, "div", 3);
    i0.ɵɵelementStart(2, "div", 3);
    i0.ɵɵelementStart(3, "div", 4);
    i0.ɵɵelementStart(4, "button", 5);
    i0.ɵɵtext(5, "Upload a file");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(6, "input", 6, 7);
    i0.ɵɵlistener("change", function OverideUploadFormsLibraryComponent_div_1_Template_input_change_6_listener($event) { i0.ɵɵrestoreView(_r4); const ctx_r3 = i0.ɵɵnextContext(); return ctx_r3.uploadForm($event.target.files); });
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(8, "div", 8);
    i0.ɵɵtext(9, "(Supported file type: .pdf)");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance(4);
    i0.ɵɵproperty("disabled", ctx_r0.disabledControls);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("accept", ctx_r0.acceptedTypes)("disabled", ctx_r0.disabledControls);
} }
const _c0 = function (a0) { return { "disabled": a0 }; };
function OverideUploadFormsLibraryComponent_table_2_Template(rf, ctx) { if (rf & 1) {
    const _r6 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "table", 9);
    i0.ɵɵelementStart(1, "thead", 10);
    i0.ɵɵelementStart(2, "tr");
    i0.ɵɵelementStart(3, "th");
    i0.ɵɵtext(4, "Document Type");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(5, "th");
    i0.ɵɵtext(6, "Document Name");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(7, "th");
    i0.ɵɵtext(8, "Uploaded On");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(9, "th", 11);
    i0.ɵɵtext(10, " Actions ");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(11, "tbody");
    i0.ɵɵelementStart(12, "tr");
    i0.ɵɵelementStart(13, "td");
    i0.ɵɵelementStart(14, "strong");
    i0.ɵɵtext(15);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(16, "td", 12);
    i0.ɵɵtext(17);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(18, "td", 12);
    i0.ɵɵtext(19);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(20, "td", 12);
    i0.ɵɵelementStart(21, "div", 13);
    i0.ɵɵelementStart(22, "div", 14);
    i0.ɵɵelementStart(23, "mat-icon", 15);
    i0.ɵɵlistener("click", function OverideUploadFormsLibraryComponent_table_2_Template_mat_icon_click_23_listener() { i0.ɵɵrestoreView(_r6); const ctx_r5 = i0.ɵɵnextContext(); return ctx_r5.viewDocument(ctx_r5.fileSrc); });
    i0.ɵɵtext(24, "visibility");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(25, "div", 14);
    i0.ɵɵelementStart(26, "span");
    i0.ɵɵelementStart(27, "mat-icon", 16);
    i0.ɵɵlistener("click", function OverideUploadFormsLibraryComponent_table_2_Template_mat_icon_click_27_listener() { i0.ɵɵrestoreView(_r6); const ctx_r7 = i0.ɵɵnextContext(); return ctx_r7.deleteUploadedDocument(ctx_r7.formName, ctx_r7.documentID); });
    i0.ɵɵtext(28, "delete");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance(15);
    i0.ɵɵtextInterpolate(ctx_r1.formName);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", ctx_r1.uploadedFileName, " ");
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", ctx_r1.UploadingTime, " ");
    i0.ɵɵadvance(8);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(4, _c0, ctx_r1.disabledControls));
} }
class OverideUploadFormsLibraryComponent {
    constructor(store, toastr, apiService, stepStatusUpdatePayloadCostructionService, referenceLibraryService, overideUploadFormsLibraryService) {
        this.store = store;
        this.toastr = toastr;
        this.apiService = apiService;
        this.stepStatusUpdatePayloadCostructionService = stepStatusUpdatePayloadCostructionService;
        this.referenceLibraryService = referenceLibraryService;
        this.overideUploadFormsLibraryService = overideUploadFormsLibraryService;
        this.onDialogClose = new EventEmitter();
        this.deleteUpload = new EventEmitter();
        this.uploadData = new EventEmitter();
        this.deleteData = new EventEmitter();
        this.observableSubscription$ = new Subject$1();
        this.stepDetails = TaskStep;
        this.disabledControls = false;
        this.acceptedTypes = acceptedFileTypes;
    }
    ngOnInit() {
    }
    ngOnChanges() {
        var _a;
        this.inputData = this.primaryData;
        if ((_a = this.inputData) === null || _a === void 0 ? void 0 : _a.stepId) {
            if (this.inputData.greenCard) {
                this.overideUploadFormsLibraryService.fetchi140StepDetails.next(this.inputData.stepId);
                this.overideUploadFormsLibraryService.receivei140StepDetails
                    .pipe(takeUntil(this.observableSubscription$))
                    .subscribe((data) => {
                    this.stepDetails = data;
                    this.toggleControlsStatus();
                });
            }
            else {
                this.store.pipe(select(getStepDetails, { id: this.inputData.stepId }))
                    .pipe(takeUntil(this.observableSubscription$))
                    .subscribe((data) => {
                    this.stepDetails = data;
                    this.toggleControlsStatus();
                });
            }
        }
    }
    handleClose() {
        this.onDialogClose.emit();
    }
    ngOnDestroy() {
    }
    viewDocument(url) {
        const docPath = url.substring(23);
        window.open(`${environment.docs}${docPath}`, '_blank');
    }
    uploadForm(_data) {
        let files = _data[0];
        // if (files.type !== 'application/pdf') {
        //   this.toastr.error("You have selected wrong document", "Please upload PDF file")
        // }
        // else {
        this.selectedFile = files;
        const formData = new FormData();
        formData.append('file', this.selectedFile);
        if (this.familyId == undefined) {
            this.familyId = '';
        }
        if (this.isGreenCard) {
            this.uploadData.emit({ formName: this.formName, file: _data });
        }
        else {
            this.apiService.uploadDocument(this.inputData.visatype, this.inputData.caseType, this.inputData.caseId, this.inputData.superTaskId, this.inputData.subTaskId, this.formName, this.familyId, formData)
                .pipe(takeUntil(this.observableSubscription$))
                .subscribe((response) => {
                if (response.status == 200) {
                    this.toastr.success(response.message, "Success");
                    let documentId = response.data.id;
                    let fileName = response.data.fileCategory.code;
                    let generatedOn = response.data.generatedOn;
                    let isGenerated = response.data.isGenerated;
                    let isUploaded = response.data.isUploaded;
                    let getURL = response.data.fileLocation;
                    let formType = this.formType;
                    let currentIndex = this.currentIndex;
                    let subIndex = this.subIndex;
                    let uploadedFileName = response.data.uploadedFileName;
                    let generateActive = response.data.isActive;
                    let familyId = response.data.familyId;
                    this.uploadData.emit({ familyId: familyId, fileName: fileName, documentID: documentId, generatedOn: generatedOn, isGenerated: isGenerated, isUploaded: isUploaded, getUrl: getURL, formType: formType, currentIndex: currentIndex, subIndex: subIndex, uploadedFileName: uploadedFileName, isActive: generateActive });
                }
            });
        }
        // }
    }
    deleteUploadedDocument(formName, documentId) {
        if (this.isGreenCard) {
            this.deleteData.emit({ documentId: documentId });
        }
        else {
            if (this.inputData.caseType == "I130") {
                this.apiService.deleteGreenCardUploadDocument(documentId).pipe(takeUntil(this.observableSubscription$)).subscribe((response) => {
                    this.toastr.success(response.message, "Success");
                    let documentId = response.data.id;
                    let fileName = response.data.fileCategory.code;
                    let generatedOn = response.data.generatedOn;
                    let isGenerated = response.data.isGenerated;
                    let isUploaded = response.data.isUploaded;
                    let getURL = response.data.fileLocation;
                    let formType = this.formType;
                    let currentIndex = this.currentIndex;
                    let subIndex = this.subIndex;
                    let familyId = response.data.familyId;
                    localStorage.setItem("overrideRadioG28", null);
                    localStorage.setItem("overrideRadioI129", null);
                    localStorage.setItem("overrideRadioI907", null);
                    localStorage.setItem("overrideRadioI130", null);
                    localStorage.setItem("overrideRadioI130A", null);
                    localStorage.setItem("overrideRadioI130PREP", null);
                    localStorage.setItem("overrideRadioI130INTPTR", null);
                    this.deleteData.emit({ familyId: familyId, fileName: fileName, documentID: documentId, generatedOn: generatedOn, isGenerated: isGenerated, isUploaded: isUploaded, getUrl: getURL, formType: formType, currentIndex: currentIndex, subIndex: subIndex });
                });
            }
            else {
                this.apiService.deleteUploadDocument(documentId, this.inputData.companyId, this.inputData.petitionId)
                    .pipe(takeUntil(this.observableSubscription$))
                    .subscribe((response) => {
                    if (response.status == 200) {
                        this.toastr.success(response.message, "Success");
                        let documentId = response.data.id;
                        let fileName = response.data.fileCategory.code;
                        let generatedOn = response.data.generatedOn;
                        let isGenerated = response.data.isGenerated;
                        let isUploaded = response.data.isUploaded;
                        let getURL = response.data.fileLocation;
                        let formType = this.formType;
                        let currentIndex = this.currentIndex;
                        let subIndex = this.subIndex;
                        let familyId = response.data.familyId;
                        localStorage.setItem("overrideRadioG28", null);
                        localStorage.setItem("overrideRadioI129", null);
                        localStorage.setItem("overrideRadioI907", null);
                        localStorage.setItem("overrideRadioI130", null);
                        localStorage.setItem("overrideRadioI130A", null);
                        localStorage.setItem("overrideRadioI130PREP", null);
                        localStorage.setItem("overrideRadioI130INTPTR", null);
                        this.deleteData.emit({ familyId: familyId, fileName: fileName, documentID: documentId, generatedOn: generatedOn, isGenerated: isGenerated, isUploaded: isUploaded, getUrl: getURL, formType: formType, currentIndex: currentIndex, subIndex: subIndex });
                    }
                });
            }
        }
    }
    toggleControlsStatus() {
        this.disabledControls =
            this.stepDetails.stepStatusDetails.stepStatusCode === "NEW" ||
                this.stepDetails.stepStatusDetails.stepStatusCode === "COMPLETE" ||
                this.stepDetails.stepStatusDetails.stepStatusCode === "SUBMIT";
    }
}
OverideUploadFormsLibraryComponent.ɵfac = function OverideUploadFormsLibraryComponent_Factory(t) { return new (t || OverideUploadFormsLibraryComponent)(i0.ɵɵdirectiveInject(i1.Store), i0.ɵɵdirectiveInject(i2.ToastrService), i0.ɵɵdirectiveInject(i3.APIGenerateForms), i0.ɵɵdirectiveInject(i4.StepStatusUpdatePayloadService), i0.ɵɵdirectiveInject(i5.ReferenceLibraryService), i0.ɵɵdirectiveInject(OverideUploadFormsLibraryService)); };
OverideUploadFormsLibraryComponent.ɵcmp = i0.ɵɵdefineComponent({ type: OverideUploadFormsLibraryComponent, selectors: [["lib-overide-upload-forms-library"]], inputs: { primaryData: "primaryData", formName: "formName", isGenerated: "isGenerated", isUploaded: "isUploaded", UploadingTime: "UploadingTime", fileSrc: "fileSrc", documentID: "documentID", formType: "formType", currentIndex: "currentIndex", subIndex: "subIndex", familyId: "familyId", isGreenCard: "isGreenCard", uploadedFileName: "uploadedFileName" }, outputs: { onDialogClose: "onDialogClose", deleteUpload: "deleteUpload", uploadData: "uploadData", deleteData: "deleteData" }, features: [i0.ɵɵNgOnChangesFeature], decls: 3, vars: 2, consts: [["class", "row", 4, "ngIf"], ["class", "im-card-no-border-table file-upload-list table-striped-simple", "style", "margin-top: 30px; width: 100%;", 4, "ngIf"], [1, "row"], [1, "col-6"], [1, "upload-btn-wrapper"], [1, "btn-success", "btn", 3, "disabled"], ["type", "file", "name", "myfile", 3, "accept", "disabled", "change"], ["myfile", ""], [1, "supportFileText"], [1, "im-card-no-border-table", "file-upload-list", "table-striped-simple", 2, "margin-top", "30px", "width", "100%"], [2, "height", "30px"], [1, "text-center"], ["nowrap", ""], [1, "d-flex", "flex-row", "align-items-center", "justify-content-center"], [1, "mr-2", "padding0"], ["matTooltipClass", "tooltip-bg", "matTooltip", "View Document", 1, "material-icons", 3, "click"], ["matTooltipClass", "tooltip-bg", "matTooltip", "Delete Document", 1, "material-icons", 3, "ngClass", "click"]], template: function OverideUploadFormsLibraryComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "div");
        i0.ɵɵtemplate(1, OverideUploadFormsLibraryComponent_div_1_Template, 10, 3, "div", 0);
        i0.ɵɵtemplate(2, OverideUploadFormsLibraryComponent_table_2_Template, 29, 6, "table", 1);
        i0.ɵɵelementEnd();
    } if (rf & 2) {
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", !ctx.isGenerated);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", !ctx.isGenerated && ctx.isUploaded);
    } }, directives: [i7.NgIf, i8.MatIcon, i7.NgClass], styles: [".upload-btn-wrapper[_ngcontent-%COMP%]{position:relative;overflow:hidden;display:inline-block;margin-top:20px}.btn[_ngcontent-%COMP%]{border:0;color:#fff;padding:8px 20px;border-radius:8px;font-size:20px;font-weight:700}.upload-btn-wrapper[_ngcontent-%COMP%]   input[type=file][_ngcontent-%COMP%]{font-size:100px;position:absolute;left:0;top:0;opacity:0}.supportFileText[_ngcontent-%COMP%]{font-size:11px;font-style:italic;color:#d3d3d3}.disabled[_ngcontent-%COMP%]{pointer-events:none}"] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(OverideUploadFormsLibraryComponent, [{
        type: Component,
        args: [{
                selector: 'lib-overide-upload-forms-library',
                templateUrl: 'overide-upload-forms-library.component.html',
                styleUrls: ['overide-upload-forms-library.component.scss']
            }]
    }], function () { return [{ type: i1.Store }, { type: i2.ToastrService }, { type: i3.APIGenerateForms }, { type: i4.StepStatusUpdatePayloadService }, { type: i5.ReferenceLibraryService }, { type: OverideUploadFormsLibraryService }]; }, { primaryData: [{
            type: Input
        }], formName: [{
            type: Input
        }], isGenerated: [{
            type: Input
        }], isUploaded: [{
            type: Input
        }], UploadingTime: [{
            type: Input
        }], fileSrc: [{
            type: Input
        }], documentID: [{
            type: Input
        }], formType: [{
            type: Input
        }], currentIndex: [{
            type: Input
        }], subIndex: [{
            type: Input
        }], familyId: [{
            type: Input
        }], isGreenCard: [{
            type: Input
        }], uploadedFileName: [{
            type: Input
        }], onDialogClose: [{
            type: Output
        }], deleteUpload: [{
            type: Output
        }], uploadData: [{
            type: Output
        }], deleteData: [{
            type: Output
        }] }); })();

class OverideUploadFormsLibraryModule {
}
OverideUploadFormsLibraryModule.ɵfac = function OverideUploadFormsLibraryModule_Factory(t) { return new (t || OverideUploadFormsLibraryModule)(); };
OverideUploadFormsLibraryModule.ɵmod = i0.ɵɵdefineNgModule({ type: OverideUploadFormsLibraryModule });
OverideUploadFormsLibraryModule.ɵinj = i0.ɵɵdefineInjector({ providers: [BaseGenerateFormsLibraryService], imports: [[
            PrimengLibraryModule
        ]] });
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && i0.ɵɵsetNgModuleScope(OverideUploadFormsLibraryModule, { declarations: [OverideUploadFormsLibraryComponent], imports: [PrimengLibraryModule], exports: [OverideUploadFormsLibraryComponent] }); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(OverideUploadFormsLibraryModule, [{
        type: NgModule,
        args: [{
                declarations: [OverideUploadFormsLibraryComponent],
                imports: [
                    PrimengLibraryModule
                ],
                providers: [BaseGenerateFormsLibraryService],
                exports: [OverideUploadFormsLibraryComponent]
            }]
    }], null, null); })();

/*
 * Public API Surface of overide-upload-forms-library
 */

/**
 * Generated bundle index. Do not edit.
 */

export { OverideUploadFormsLibraryComponent, OverideUploadFormsLibraryModule, OverideUploadFormsLibraryService };
//# sourceMappingURL=overide-upload-forms-library.js.map
